import { render, staticRenderFns } from "./OrderReceipt.vue?vue&type=template&id=c9fab0d0&scoped=true&"
import script from "./OrderReceipt.vue?vue&type=script&lang=ts&"
export * from "./OrderReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./OrderReceipt.vue?vue&type=style&index=0&id=c9fab0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fab0d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
